import * as React from 'react'

export const AdminUsers = () => {
  return (
    <div>
      <div />
    </div>
  )
}
